<template>
  <div>
    <Loader :loading="showLoader" />
    <v-toolbar color="#222222" flat dense class="mb-4">
      <v-icon color="#337b52" class="ml-2" size="40" @click="goBack">
        mdi-arrow-left-bold-circle
      </v-icon>
      <v-toolbar-title style="font-family: 'Material Design Icons'; font-size: 25px !important">
        {{ toobarTitle }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-container fluid class="main-content px-4">
      <v-row justify="center" align="stretch" class="ma-0">
        <v-col v-for="(card, index) in cards" :key="index" cols="12" sm="6" md="4" lg="3" class="pa-3 d-flex">
          <v-card class="elegant-card no-transition hand-cursor">
            <img :src="card.image" class="card-image" />
            <div class="card-bottom">
              <div class="card-title">{{ card.text }}</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
import { onMounted, ref, onUnmounted, watch } from "vue";
import Loader from "@/components/Loader.vue";
import { getToolBarLogo } from "@/assets/Branding/branding.js";
import { useRouter, useRoute } from "vue-router";
import BuildingA from "@/assets/Branding/Artinvest/AlterWallFloorsPictures/building_a.jpg";
import BuildingB from "@/assets/Branding/Artinvest/AlterWallFloorsPictures/building_b.jpg";
import BuildingC from "@/assets/Branding/Artinvest/AlterWallFloorsPictures/building_c.jpg";
import BuildingD from "@/assets/Branding/Artinvest/AlterWallFloorsPictures/building_d.jpg";

export default {
  name: 'AlterWallFloorsView',
  components: {
    Loader,
  },
  setup() {
    const showLoader = ref(true);
    const logo = ref("");
    const router = useRouter();
    const route = useRoute();
    const selectedCard = ref(0);
    const toobarTitle = ref("Alter Wall Grundrisse");
    const cards = ref([
      { text: "Gebäude A - Hotel", image: BuildingA },
      { text: "Gebäude B - Büro", image: BuildingB },
      { text: "Gebäude C - Whonen", image: BuildingC },
      { text: "Gebäude D - Büro", image: BuildingD },
    ]);

    const goBack = () => {
      router.go(-1);
    };

    const isMobile = ref(window.innerWidth < 1024);

    const updateIsMobile = () => {
      isMobile.value = window.innerWidth < 1024;
    };

    window.addEventListener('resize', updateIsMobile);

    onMounted(async () => {
      showLoader.value = true;
      logo.value = await getToolBarLogo();
      setTimeout(() => {
        showLoader.value = false;
      }, 800);
      updateIsMobile();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateIsMobile);
    });

    watch(route, (newRoute) => {
      const hash = newRoute.hash;
      if (hash === "#artInvestapproach") {
        selectedCard.value = 1;
        toobarTitle.value = "Unser Ansatz am Alten Wall";
      } else if (hash === "#artInvestexplanation") {
        selectedCard.value = 2;
        toobarTitle.value = "ArtInvest Kurzerklärung";
      } else if (hash === "#dialinhbk") {
        selectedCard.value = 3;
        toobarTitle.value = "Einwahl-HBK";
      } else {
        selectedCard.value = 0;
        toobarTitle.value = "Alter Wall Grundrisse";
      }
    }, { immediate: true });

    return {
      showLoader,
      logo,
      goBack,
      cards,
      selectedCard,
      isMobile,
      toobarTitle
    };
  }
};
</script>

<style scoped>
.toolbar-icon {
  height: 30px;
  align-self: center;
  margin-right: 20px;
}

.elegant-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: none !important;
  animation: none !important;
}

.card-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.card-bottom {
  background-color: #fff;
  width: 100%;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.card-title {
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  color: #000;
}
</style>
